import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import twoFactorAb5595 from './two-factor'
/**
* @see \App\Http\Controllers\AuthController::username
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
export const username = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: username.url(options),
    method: 'post',
})

username.definition = {
    methods: ["post"],
    url: '/login/help/username',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::username
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
username.url = (options?: RouteQueryOptions) => {
    return username.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::username
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
username.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: username.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::username
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
    const usernameForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: username.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::username
 * @see app/Http/Controllers/AuthController.php:374
 * @route '/login/help/username'
 */
        usernameForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: username.url(options),
            method: 'post',
        })
    
    username.form = usernameForm
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
export const twoFactor = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: twoFactor.url(options),
    method: 'get',
})

twoFactor.definition = {
    methods: ["get","head"],
    url: '/login/help/two-factor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
twoFactor.url = (options?: RouteQueryOptions) => {
    return twoFactor.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
twoFactor.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: twoFactor.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
twoFactor.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: twoFactor.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
    const twoFactorForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: twoFactor.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
        twoFactorForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: twoFactor.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\TwoFactorRecoveryController::twoFactor
 * @see app/Http/Controllers/TwoFactorRecoveryController.php:29
 * @route '/login/help/two-factor'
 */
        twoFactorForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: twoFactor.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    twoFactor.form = twoFactorForm
const help = {
    username: Object.assign(username, username),
twoFactor: Object.assign(twoFactor, twoFactorAb5595),
}

export default help